/**
 * This composable is used to emit an event once.
 * @param emit - The component's `emit` function to emit the event.
 *
 * It uses `JSON.stringify` to compare the arguments in
 * subsequent calls.
 */
export function useEmitOnce<T extends [string, ...unknown[]]>(
  emit: (...args: T) => void,
) {
  const cache = new Set<string>()

  const emitOnce = (...args: T) => {
    // Create a unique key by encoding all arguments
    const key = JSON.stringify(args)

    if (cache.has(key)) {
      return
    }

    cache.add(key)
    emit(...args)
  }

  return {
    emitOnce,
  }
}
